<template lang="html">
  <div class="admin-wrapper-background">
    <div class="admin-wrapper">
      <div class="admin-links">
        <div v-for="link in links" :key="link.id" class="link-wrapper">
          <div @click="link.open = !link.open" class="link-title">
            <span>{{ link.label }}</span>
            <div class="dropdown-arrow-wrapper">
              <img
                src="@/assets/icons/dropdownArrow.png"
                alt="dropdown arrow icon"
              />
            </div>
          </div>
          <div v-if="link.open" class="link-dropdown">
            <div
              :class="{ active: activeLink === subLink.id }"
              @click="setActive(subLink)"
              v-for="subLink in link.subLinks"
              :key="subLink.id"
              class="dropdown-title"
            >
              {{ subLink.label }}
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <keep-alive>
          <component
            :codebookData="codebookData"
            v-bind:is="activeComponent"
          ></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import AdminStatistics from '@/components/admin/statistics.vue'
import Codebook from '@/components/admin/codebook.vue'
import Users from '@/components/admin/users.vue'
import Products from '@/components/admin/products.vue'
import Offers from '@/components/admin/offers.vue'
import Report from '@/components/admin/report.vue'
import Sugestions from '@/components/admin/sugestions.vue'
import Email from '@/components/admin/email.vue'
import Images from '@/components/admin/images.vue'
import Files from '@/components/admin/files.vue'
import FilesFranchise from '@/components/admin/filesFranchise.vue'
import Groups from '@/components/admin/groups.vue'
import News from '@/components/admin/news.vue'
import HelpMessages from '@/components/admin/helpMessages.vue'
import Comments from '@/components/admin/comments.vue'
import Cancellations from '@/components/admin/cancellations.vue'
import Rejections from '@/components/admin/rejections.vue'
import Buyings from '@/components/admin/buyings.vue'
import Faq from '@/components/admin/faq.vue'
import AdminCompetitions from '@/components/admin/competitions.vue'
import CompetitionRules from '@/components/admin/competitionRules.vue'
import CompetitionWorks from '@/components/admin/competitionWorks.vue'
export default {
  name: 'Admin',
  components: {
    AdminStatistics,
    Codebook,
    Users,
    Products,
    Offers,
    Report,
    Sugestions,
    Email,
    Images,
    Groups,
    News,
    Comments,
    Cancellations,
    Buyings,
    Faq,
    AdminCompetitions,
    CompetitionRules,
    CompetitionWorks,
    FilesFranchise
  },
  data () {
    return {
      activeComponent: AdminStatistics,
      activeLink: 1,
      codebookData: null,
      links: [
        {
          id: 1,
          open: true,
          label: 'opšte',
          subLinks: [
            {
              id: Math.random().toString(),
              component: AdminStatistics,
              label: 'Statistika'
            },
            {
              id: Math.random().toString(),
              component: Report,
              label: 'Izveštaji'
            }
          ]
        },
        {
          id: 2,
          open: false,
          label: 'šifarnici',
          subLinks: [
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Države',
              codebookData: {
                getApi: 'getCountries',
                patchApi: 'patchCountry',
                active: 'cnt_active',
                post: {
                  title: 'Dodaj drzavu',
                  postApi: 'setCountries',
                  inputs: [
                    {
                      key: 'cnt_name',
                      label: 'Ime drzave',
                      value: null
                    },
                    {
                      key: 'cnt_iso2',
                      label: 'Iso skracenica drzave - 2 karaktera',
                      value: null
                    },
                    {
                      type: 'dropdown',
                      dropdownApi: 'getCurrencies',
                      dropdownList: [],
                      key: 'cur_id',
                      label: 'Izaberite valutu',
                      value: null
                    }
                  ]
                },
                key: 'cnt_id',
                name: 'cnt_name',
                label: 'drzave'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Kategorije',
              codebookData: {
                getApi: 'getCategoriesAdmin',
                patchApi: 'patchCategory',
                active: 'cat_active',
                post: {
                  title: 'Dodaj kategoriju',
                  postApi: 'setCategory',
                  inputs: [
                    {
                      key: 'cat_name',
                      label: 'Ime kategorije',
                      value: null
                    },
                    {
                      type: 'dropdown',
                      dropdownApi: 'getParentCategories',
                      dropdownList: [],
                      key: 'cat_id_parent',
                      label: 'Izaberite parent kategoriju (optional)',
                      value: null
                    }
                  ]
                },
                edit: 'adminEditCategory',
                key: 'cat_id',
                name: 'cat_name',
                label: 'kategorije'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Valute',
              codebookData: {
                getApi: 'getCurrenciesAll',
                patchApi: 'patchCurrency',
                active: 'cur_active',
                post: {
                  title: 'Dodaj valutu',
                  postApi: 'setCurrency',
                  inputs: [
                    {
                      key: 'cur_name',
                      label: 'ime valute (dinar)',
                      value: null
                    },
                    {
                      key: 'cur_id',
                      label: 'kod valute (RSD)',
                      value: null
                    }
                  ]
                },
                key: 'cur_id',
                name: 'cur_id',
                label: 'valute'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Merne jedinice',
              codebookData: {
                getApi: 'getMeasurementUnitsAll',
                patchApi: 'patchMeasurementUnits',
                active: 'mun_active',
                post: {
                  title: 'Dodaj mernu jedinicu',
                  postApi: 'setMeasurementUnits',
                  inputs: [
                    {
                      key: 'mun_name',
                      label: 'naziv merne jedinice',
                      value: null
                    },
                    {
                      key: 'mun_unit',
                      label: 'skraćenica merne jedinice',
                      value: null
                    }
                  ]
                },
                key: 'mun_id',
                name: 'mun_unit',
                label: 'Merne jedinice'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Delatnosti',
              codebookData: {
                getApi: 'getServices',
                patchApi: 'patchServices',
                active: 'osr_active',
                post: {
                  title: 'Dodaj delatnost',
                  postApi: 'setServices',
                  inputs: [
                    {
                      key: 'osr_name',
                      label: 'Naziv delatnosti',
                      value: null
                    }
                  ]
                },
                key: 'osr_id',
                name: 'osr_name',
                label: 'Delatnosti'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Oblici organizovanja',
              codebookData: {
                getApi: 'getOrganisationTypeAll',
                patchApi: 'patchOrganisationType',
                active: 'otp_active',
                post: {
                  title: 'Dodaj delatnost',
                  postApi: 'setOrganisationType',
                  inputs: [
                    {
                      key: 'otp_name',
                      label: 'Naziv oblika organizovanja',
                      value: null
                    }
                  ]
                },
                key: 'otp_id',
                name: 'otp_name',
                label: 'Oblici organizovanja'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Klauzule opšte',
              codebookData: {
                getApi: 'getClausesAll',
                patchApi: 'patchClauses',
                active: 'trc_active',
                post: {
                  title: 'Dodaj klauzulu',
                  postApi: 'setClauses',
                  inputs: [
                    {
                      key: 'trc_description',
                      label: 'Naziv klauzule',
                      value: null
                    },
                    {
                      key: 'trc_code',
                      label: 'Kod klauzule',
                      value: null
                    }
                  ]
                },
                key: 'trc_id',
                name: 'trc_description',
                label: 'Klauzule opšte'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Klauzule pomorske',
              codebookData: {
                getApi: 'getClausesNavalAll',
                patchApi: 'patchClausesNaval',
                active: 'trc_active',
                post: {
                  title: 'Dodaj klauzulu',
                  postApi: 'setClausesNaval',
                  inputs: [
                    {
                      key: 'trc_description',
                      label: 'Naziv klauzule',
                      value: null
                    },
                    {
                      key: 'trc_code',
                      label: 'Kod klauzule',
                      value: null
                    }
                  ]
                },
                key: 'trc_id',
                name: 'trc_description',
                label: 'Klauzule pomorske'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Ograničenja',
              codebookData: {
                getApi: 'getRestrictionsAll',
                patchApi: 'patchRestrictions',
                active: 'rst_active',
                post: {
                  title: 'Dodaj restrikciju',
                  postApi: 'setRestrictions',
                  inputs: [
                    {
                      key: 'rst_name',
                      label: 'Naziv restrikcije',
                      value: null
                    },
                    {
                      key: 'rst_start_time',
                      label: 'Vreme od:',
                      value: null,
                      type: 'time'
                    },
                    {
                      key: 'rst_end_time',
                      label: 'Vreme do:',
                      value: null,
                      type: 'time'
                    }
                  ]
                },
                key: 'rst_id',
                name: 'rst_name',
                label: 'Restrikcije'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Zabranjene reči',
              codebookData: {
                getApi: 'getRestrictedWords',
                patchApi: 'patchRestrictedWords',
                active: 'rsw_active',
                post: {
                  title: 'Dodaj zabranjenu reč',
                  postApi: 'setRestrictedWord',
                  inputs: [
                    {
                      key: 'rsw_word',
                      label: 'Zabranjena reč',
                      value: null
                    }
                  ]
                },
                key: 'rsw_id',
                name: 'rsw_word',
                label: 'Zabranjene reči'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Društvene mreže',
              codebookData: {
                getApi: 'getSocialTypesAll',
                patchApi: 'patchSocialType',
                active: 'sct_active',
                post: {
                  title: 'Dodaj društvenu mrežu',
                  postApi: 'setSocialType',
                  inputs: [
                    {
                      key: 'sct_name',
                      label: 'Naziv društvene mreže',
                      value: null
                    }
                  ]
                },
                key: 'sct_id',
                name: 'sct_name',
                label: 'Društvene mreže'
              }
            },
            {
              id: Math.random().toString(),
              component: Codebook,
              label: 'Adrese za obaveštenja',
              codebookData: {
                getApi: 'getNewsletter',
                patchApi: 'patchNewsletter',
                active: 'nws_active',
                key: 'nws_id',
                name: 'nws_email',
                label: 'Adrese za obaveštenja'
              }
            }
          ]
        },
        {
          id: 3,
          open: false,
          label: 'Održavanje Sistema',
          subLinks: [
            {
              id: Math.random().toString(),
              component: Users,
              label: 'Korisnički nalozi'
            },
            {
              id: Math.random().toString(),
              component: Products,
              label: 'Objave'
            },
            {
              id: Math.random().toString(),
              component: Offers,
              label: 'Ponude'
            },
            {
              id: Math.random().toString(),
              component: Sugestions,
              label: 'Sugestije'
            },
            {
              id: Math.random().toString(),
              component: Comments,
              label: 'Komentari'
            },
            {
              id: Math.random().toString(),
              component: Cancellations,
              label: 'Obrisane objave'
            },
            {
              id: Math.random().toString(),
              component: Rejections,
              label: 'Odbijanja'
            },
            {
              id: Math.random().toString(),
              component: Buyings,
              label: 'Kupovine'
            },
            {
              id: Math.random().toString(),
              component: Email,
              label: 'Slanje obaveštenja'
            },
            {
              id: Math.random().toString(),
              component: Images,
              label: 'Reklamne slike'
            },
            {
              id: Math.random().toString(),
              component: Files,
              label: 'Dokumenti'
            },
            {
              id: Math.random().toString(),
              component: FilesFranchise,
              label: 'Franšize'
            },
            {
              id: Math.random().toString(),
              component: Groups,
              label: 'Grupe objava'
            },
            {
              id: Math.random().toString(),
              component: News,
              label: 'Vesti'
            },
            {
              id: Math.random().toString(),
              component: HelpMessages,
              label: 'Pomoćne poruke'
            },
            {
              id: Math.random().toString(),
              component: Faq,
              label: 'FAQ'
            },
            {
              id: Math.random().toString(),
              component: AdminCompetitions,
              label: 'Konkursi'
            },
            {
              id: Math.random().toString(),
              component: CompetitionRules,
              label: 'Konkursi - dokumenti'
            },
            {
              id: Math.random().toString(),
              component: CompetitionWorks,
              label: 'Konkursi - radovi'
            }
          ]
        }
      ]
    }
  },
  methods: {
    setActive (subLink) {
      this.activeComponent = subLink.component
      this.activeLink = subLink.id
      if (subLink.codebookData) {
        this.codebookData = subLink.codebookData
      } else {
        this.codebookData = null
      }
    }
  },
  watch: {
    '$i18n.locale': {
      handler (newLocale, oldLocale) {
        if (newLocale !== oldLocale) {
          this.$forceUpdate()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-wrapper-background {
  background: #f2f2f2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;

  .admin-wrapper {
    display: flex;
    height: 100%;
    max-width: 1600px;
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    background: white;
    padding: 40px 40px 40px 0px;
    box-sizing: border-box;

    .admin-links {
      width: 260px;
      min-width: 260px;
      border-right: 1px solid #eaeaea;
      padding: 0 25px;

      .link-wrapper {
        margin-bottom: 20px;
        .link-title {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          font-weight: bold;
          font-size: 16px;
          line-height: 26px;
          letter-spacing: 0.06em;
          color: #484848;
          text-transform: uppercase;

          .dropdown-arrow-wrapper {
            display: flex;
            align-items: center;
          }

          span,
          div {
            cursor: pointer;
          }
        }
        .link-dropdown {
          .dropdown-title {
            text-align: left;
            padding-left: 10px;
            font-weight: 500;
            font-size: 13px;
            line-height: 21px;
            letter-spacing: 0.06em;
            color: #8a8a8a;
            cursor: pointer;
            margin-bottom: 10px;
          }
          .dropdown-title.active {
            color: #3f3f3f;
          }
        }
      }
    }
    .content {
      flex-grow: 1;
      max-height: calc(100vh - 200px);
      overflow-y: auto;
      @import '@/assets/scss/scrollbarStyles.scss';
      @include scrollbar;
      padding-right: 5px;
    }
  }
}
</style>
